import axios from 'axios';

const API_URL = '/api/signals';

// 信号列表(管理端)
// params: { page, limit, sourceId, status, signalType }
export const getSignals = async (params = {}) => {
  try {
    const response = await axios.get(API_URL, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '获取信号列表失败' };
  }
};

// 信号分发详情(某信号生成了哪些指令)
export const getSignalCommands = async (id, params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/${id}/commands`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '获取信号分发详情失败' };
  }
};

// 取消待分发的信号
export const cancelSignal = async (id) => {
  try {
    const response = await axios.post(`${API_URL}/${id}/cancel`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '取消信号失败' };
  }
};

// 信号状态中文名 + 配色
export const signalStatusMeta = (s) => {
  const map = {
    pending: { name: '待分发', cls: 'bg-[#fff8c5] text-[#9a6700]' },
    dispatched: { name: '已分发', cls: 'bg-[#dafbe1] text-[#1a7f37]' },
    cancelled: { name: '已取消', cls: 'bg-[#f6f8fa] text-[#57606a]' }
  };
  return map[s] || { name: s, cls: 'bg-[#f6f8fa] text-[#57606a]' };
};
